<template>
  <div>
    <div class="d-flex justify-space-between">
      <page-title value="Extended Childcare Patterns"></page-title>
      <v-btn variant="flat" color="primary" to="/nursery-hours/edit">
        <v-icon start>mdi-plus</v-icon>
        Create New
      </v-btn>
    </div>

    <v-progress-linear indeterminate v-if="isLoading"></v-progress-linear>

    <div class="my-8">
      <v-table fixed-header>
        <template v-slot:default>
          <thead>
            <tr>
              <th>Pattern Name</th>
              <th>Monthly/Spot</th>
              <th>Created Date</th>
              <th>Default Setting</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in patternList" :key="i">
              <td>{{ item.patternTitle }}</td>
              <td>{{ getCategoryName(item.category) }}</td>
              <td>{{ formatDate(item.createdAt) }}</td>
              <td>
                <v-btn v-if="item.isDefault == true" color="success" variant="text"small>
                  <v-icon start>mdi-check-circle</v-icon>
                  Default
                </v-btn>
                <v-btn
                  v-else
                  @click="setDefaultPattern(item.patternId)"
                  small
                  color="grey"
                  variant="outlined"
                >
                  Set as Default
                </v-btn>
              </td>
              <td>
                <v-btn
                  @click="
                    clickEditPattern({
                      patternId: item.patternId,
                      category: item.category,
                    })
                  "
                  color="primary"
                  variant="flat"
                  small
                  >Edit</v-btn
                >
              </td>
            </tr>
          </tbody>
        </template>
      </v-table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import { NurseryHoursPatternResponse } from "chaild-api/lib";
import { nurseryHoursModule } from "@/store/dataModules/nurseryHoursModule";
import LocalDataService from "@/service/LocalDataService";
import dayjs from "dayjs";

export default defineComponent({
  name: "NurseryHours",

  components: {
    PageTitle,
  },

  async mounted() {
    await this.listPattern();
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    patternList: function (): NurseryHoursPatternResponse[] {
      return nurseryHoursModule.patternList;
    },
  },

  methods: {
    async listPattern() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await nurseryHoursModule.listPattern({
          nurseryId,
        });
      }
      this.isLoading = false;
    },
    async clickEditPattern(input: { patternId: string; category: string }) {
      this.isLoading = true;
      const response = await nurseryHoursModule.getPatternDetail({
        patternId: input.patternId,
      });
      if (response) {
        if (input.category == "monthly") {
          // monthly
          nurseryHoursModule.setMonthlyPatternInput(response);
        } else if (input.category == "spotNursery") {
          // spot nursery
          nurseryHoursModule.setSpotNurseryPatternInput(response);
          nurseryHoursModule.setSpansInput({
            patternId: response.patternId,
            spans: response.extendedBillingSpans,
          });
        } else if (input.category == "spotKindergarten") {
          // spot kindergarten
          nurseryHoursModule.setSpotKindergartenPatternInput(response);
          nurseryHoursModule.setSpansInput({
            patternId: response.patternId,
            spans: response.extendedBillingSpans,
          });
        } else if (input.category == "spotCombination") {
          // spot combination
          nurseryHoursModule.setSpotCombinationPatternInput(response);
          nurseryHoursModule.setSpansInput({
            patternId: response.patternId,
            spans: response.normalExtendedBillingSpans,
          });
        } else if (input.category == "spotFlexible") {
          nurseryHoursModule.setSpotFlexiblePatternInput(response);
          nurseryHoursModule.setSpansInput({
            patternId: response.patternId,
            spans: response.extendedBillingSpans,
          });
        }
        this.$router.push({
          path: "/nursery-hours/edit",
          query: {
            category: input.category,
            patternId: input.patternId,
          },
        });
      }
      this.isLoading = false;
    },
    async setDefaultPattern(patternId: string) {
      this.isLoading = true;
      if (patternId != null) {
        const response = await nurseryHoursModule.setDefault({
          patternId,
        });
        if (response) {
          await this.listPattern();
          alert("Default pattern has been changed");
        }
      }
      this.isLoading = false;
    },
    formatDate(value: string): string {
      return dayjs(value).format("YYYY-MM-DD hh:mm");
    },
    getCategoryName(value: string): string {
      if (value == "monthly") {
        return "Monthly";
      } else if (value == "spotNursery") {
        return "Fixed Time (Nursery)";
      } else if (value == "spotKindergarten") {
        return "Fixed Time (Kindergarten)";
      } else if (value == "spotFlexible") {
        return "Flexible Time";
      } else if (value == "spotCombination") {
        return "Morning/Evening Combined";
      } else {
        return "";
      }
    },
  },
});
</script>
